var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-contact-cont"},[_c('h1',[_vm._v("Submit a help request and we’ll get in touch shortly.")])])}]

export { render, staticRenderFns }